import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import IconButton from 'components/common/IconButton';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type MailHeaderProps = {
  table?: boolean;
  globalFilter?: string;
  setGlobalFilter?: (value: string) => void;
};

export default function MailTemplatesHeader({ globalFilter, setGlobalFilter }: MailHeaderProps) {
  const { t } = useTranslation('mailManager');

  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto">
          <h6 className="mb-0">{t('mail_requests')}</h6>
        </Col>

        <Col xs="auto">
          <AdvanceTableSearchBox
            className="input-search-width"
            globalFilter={globalFilter || ''}
            setGlobalFilter={setGlobalFilter}
            placeholder={t('search')}
          />
        </Col>
      </Row>
    </div>
  );
}
